import ScrollBtn from "./components/ScrollBtn";
import Home from "./containers/Home";
import ProjectDetail from "./containers/ProjectDetail";
import Footer from "./components/Footer";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:slug" element={<ProjectDetail />} />
      </Routes>
      <ScrollBtn />
      <Footer />
    </>
  );
}

export default App;
